export const groupByTemplate = (data) => {
    return data.reduce((acc, item) => {
      // Проверяем, существует ли уже объект с данным template в аккумуляторе
      if (!acc[item.template]) {
        acc[item.template] = {
          template: item.template,
          balance: 0,
          bonus: 0,
          sum: 0,
          unique: 0,
        };
      }
  
      // Суммируем значения
      if (item.balance) acc[item.template].balance += item.balance;
      if (item.bonus) acc[item.template].bonus += item.bonus;
      if (item.sum) acc[item.template].sum += item.sum;
      if (item.unique) acc[item.template].unique += item.unique;
  
      return acc;
    }, {});
};

export const fillMissingDates = (data, allDates) => {
    const dataMap = data.reduce((acc, item) => {
      acc[item.date] = item; // Храним оригинальные объекты, привязанные к дате
      return acc;
    }, {});
  
    return allDates.map((date) => ({
      date,
      balance: dataMap[date]?.balance || 0,
      bonus: dataMap[date]?.bonus || 0,
      unique: dataMap[date]?.unique || 0,
    }));
};

export const prepareDataWithMissingDates = (data, templates, allDates) => {
    // Создаём структуру с шаблонами и датами
    const filledData: any = [];
  
    templates.forEach((template) => {
        allDates.forEach((date) => {
            // Находим объект, соответствующий template и date
            const existingEntry: any = data.find(
                (item) => item.template === template && item.date === date
            );
    
            // Если запись найдена, добавляем её, иначе добавляем запись с нулями
            filledData.push(
                existingEntry || {
                    date,
                    balance: 0,
                    bonus: 0,
                    template,
                    unique: 0,
                }
            );
        });
    })
    return filledData;
}